import { ADD_REQUIREMENT } from '../../endpoints';
import { IRequirement } from '../../types/brand';
import makeAuthenticatedRequest from '../base-api';

interface AddRequirementResponse {
  success: boolean;
  message?: string;
  requirement?: IRequirement;
}

const requirementsQueryKey = ['requirements'];

const addRequirementApi = async (payload: IRequirement): Promise<AddRequirementResponse> => {
  try {
    const response = await makeAuthenticatedRequest(ADD_REQUIREMENT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;  
  } catch (error) {
    console.error('Add requirement failed:', error);
    throw error;
  }
};

export { addRequirementApi, type AddRequirementResponse, requirementsQueryKey };